import {
	getMyMembershipForBubble,
	getMembershipForUserAndBubble,
	setMembershipsSafe,
	setMembership,
} from '@/store'
import { post } from '@/helpers/api'
import { sStorage } from '@/helpers/utils'
import moment from 'moment'

export const checkAndFetchMembership = async (userId, bubbleId) => {
	//check for membership for a group/user and fetch it from the server if needed
	const membership = getMembershipForUserAndBubble(userId, bubbleId)
	if (membership) return membership
	var post_data = {
		bubble_id: bubbleId,
		user_id: userId,
		orderby: ['firstname', 'lastname'],
	}

	try {
		const { data } = await post('/api/v1/bubble.membershipsearch', post_data)
		setMembershipsSafe(data.memberships)
		return data.memberships[0]
	} catch (e) {
		console.error(e)
		throw e
	}
}

export const searchMemberships = async (body = {}, config = {}) => {
	const requestBody = {
		orderby: ['firstname', 'lastname'],
		includeself: true,
		...body,
		page: body.page || 1,
	}

	const resp = await post(
		'/api/v1/bubble.membershipsearch',
		requestBody,
		config
	)
	const result = {
		memberships: resp.data.memberships,
		config: resp.config,
		body: requestBody,
		next: (newConfig) => {
			const nextBody = { ...requestBody, page: requestBody.page + 1 }
			return searchMemberships(nextBody, {
				...config,
				...newConfig,
			})
		},
	}
	if (resp.data.memberships.length < resp.data.pagesize) {
		result.next = null
	}
	return result
}

export const updateMembership = async (body) => {
	try {
		const { data } = await post('/api/v1/membership.update', body)
		setMembership(data.membership)
		return data
	} catch (e) {
		console.error(e)
		throw e
	}
}

export const markChatAsUnread = async (chatId) => {
	try {
		console.debug(`Marking chat ${chatId} as unread...`)
		const marked_unread = true
		const memb = getMyMembershipForBubble(chatId)
		Object.assign(memb, {
			marked_unread,
			marked_unread_updated_at: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
		})
		setMembership(memb)
		sStorage.set(`pronto_marked_unread_${chatId}`, true)
		await updateMembership({
			bubble_id: chatId,
			marked_unread,
		})
	} catch (e) {
		console.error(e)
		throw e
	}
}

export const markChatAsRead = async (chatId) => {
	try {
		console.debug(`Marking chat ${chatId} as read...`)
		const marked_unread = false
		const memb = getMyMembershipForBubble(chatId)
		Object.assign(memb, { marked_unread })
		setMembership(memb)
		sStorage.remove(`pronto_marked_unread_${chatId}`)
		await updateMembership({
			bubble_id: chatId,
			marked_unread,
		})
	} catch (e) {
		console.error(e)
		throw e
	}
}
